module.exports = __webpack_public_path__ + "static/media/mergeContactsSmall.c56f24ed.svg";